var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpportunities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#F2EBF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0033 17.9999C22.8166 17.9999 21.6566 18.3518 20.6699 19.0111C19.6832 19.6704 18.9142 20.6075 18.46 21.7038C18.0059 22.8002 17.8871 24.0066 18.1186 25.1705C18.3501 26.3344 18.9216 27.4035 19.7607 28.2426C20.5998 29.0817 21.6689 29.6531 22.8328 29.8847C23.9967 30.1162 25.2031 29.9974 26.2994 29.5432C27.3958 29.0891 28.3329 28.3201 28.9921 27.3334C29.6514 26.3467 30.0033 25.1866 30.0033 23.9999M25.2033 13.2659C22.9786 13.0164 20.7313 13.4643 18.7723 14.5478C16.8132 15.6312 15.2393 17.2967 14.2682 19.3138C13.2971 21.3309 12.9769 23.5999 13.3517 25.8069C13.7265 28.014 14.778 30.0501 16.3606 31.6334C17.9431 33.2168 19.9787 34.2693 22.1855 34.6452C24.3924 35.0212 26.6616 34.7021 28.6792 33.732C30.6967 32.7619 32.363 31.1888 33.4475 29.2303C34.5319 27.2719 34.981 25.0248 34.7325 22.7999M27.6033 20.3999V16.7999L31.2033 13.1999V16.7999H34.8033L31.2033 20.3999H27.6033ZM27.6033 20.3999L24.0033 23.9999M22.8033 23.9999C22.8033 24.3182 22.9297 24.6234 23.1548 24.8485C23.3798 25.0735 23.6851 25.1999 24.0033 25.1999C24.3216 25.1999 24.6268 25.0735 24.8518 24.8485C25.0769 24.6234 25.2033 24.3182 25.2033 23.9999C25.2033 23.6817 25.0769 23.3765 24.8518 23.1514C24.6268 22.9264 24.3216 22.7999 24.0033 22.7999C23.6851 22.7999 23.3798 22.9264 23.1548 23.1514C22.9297 23.3765 22.8033 23.6817 22.8033 23.9999Z",
    stroke: "#7F40CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunities);
export default __webpack_public_path__ + "static/media/opportunities.1c8a96f33415c80224932c2fc1807846.svg";
export { ForwardRef as ReactComponent };